import BzbsApi from "@/core/Http/BzbsApi.js";
export default {
    config: function() {
        return {
            apiUrl: 'http://localhost:3000',
        };
    },

    apiGetBook: function(id) {
        var url = this.config().apiUrl + '/book/' + id;
        return BzbsApi.connectBzbsGet(url, null, null);
    },
}
